import styled from 'styled-components';

const Container = styled.div`
  background-color: #ffffff;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  margin-top: 35px;
  box-sizing: border-box;
  @media (max-width: 640px) {
  padding: 0 20px;
  }
  @media (min-width: 640px) {
    width: ${(props) => {
      if (props.maxWidth) {
        // maxWidth가 지정된 경우, 반응형으로 처리
        if (typeof props.maxWidth === 'string' && props.maxWidth.includes('px')) {
          // 숫자만 추출
          const maxWidthValue = parseInt(props.maxWidth, 10);
          return `min(100% - 40px, ${maxWidthValue}px)`;
        }
        return props.maxWidth;
      }
      return 'min(100% - 40px, 640px)';
    }};
    min-height: calc(100vh - 200px);
  }
  
  @media (min-width: 992px) {
    padding: 0;
    width: ${(props) => {
      if (props.maxWidth) {
        if (typeof props.maxWidth === 'string' && props.maxWidth.includes('px')) {
          const maxWidthValue = parseInt(props.maxWidth, 10);
          return `${maxWidthValue}px`;
        }
        return props.maxWidth;
      }
      return '640px';
    }};
  }
`;

export default Container;
